// フロントエンドでは使わないかも
export enum PaintVisibleKinds {
  Hide = 0,
  Print = 1,
  Preview = 2,
}
